@let depositBonusList = depositBonusList$ | async;
@let depositBonusAvailability = depositBonusAvailability$ | async;
@let isFullVerification = isFullVerification$ | async;
@let isBonusBannerClosed = isBonusBannerClosed$ | async;

@if (!!accountControl.value) {
  <card-wrapper>
    <div class="header">
      <div class="custom-select-new account-select">
        <ng-select
          data-qa="dashboard.accounts.drop-down-list"
          [clearable]="false"
          [formControl]="accountControl"
          [items]="accounts | sort : 'sort'"
          [searchable]="false"
          >
          <ng-template let-item="item" ng-label-tmp>
            <div class="i-acc i-acc--{{item.tariff}} account-select__icon"></div>
            <span class="account-select__name">{{ item | accountName: false : true }}</span>
            <global-account-type-indicator [account]="item" />
            <pac-servers-indicator [serverNames]="item | accountServer" />
          </ng-template>
          <ng-template let-item="item" ng-option-tmp>
            <div class="i-acc i-acc--{{item.tariff}} account-select__icon"></div>
            <span class="account-select__name">{{ item | accountName: false : true }}</span>
            <global-account-type-indicator [account]="item" />
            <pac-servers-indicator [serverNames]="item | accountServer" />
            <span class="account-select__balance">{{
              (item.type === _roles.TradingPlatform ? (item.balance | money) : item.balanceFixed)
              | currency: (item.currency | fixRateCurrencyConverter)
            }}</span>
          </ng-template>
          <ng-template ng-footer-tmp>
            <a
              class="open-account-link"
              data-qa = "dashboard.add-account.button"
              routerLink="accounts/real"
              >
              <icon color="#0d88e7" height="16px" name="card-plus" width="16px" />
              {{ 'dashboard.label.open-account' | translate }}
            </a>
          </ng-template>
        </ng-select>
      </div>
      @if ((accountControl.value | accountType) !== 'archived') {
        <a
          class="settings"
          [class.settings--disabled]="!accountControl.value.login"
          [routerLink]="['accounts', accountControl.value.id]"
          >
          <icon height="16px" name="settings" width="16px" />
          {{ 'dashboard.link.account-settings' | translate }}
        </a>
      }
    </div>
    @if (accountControl.value.login) {
      <div class="actions">
        <div class="balance">
          <div class="balance__title" translate="account.label.balance"></div>
          <div class="balance__value">{{
            (accountControl.value.type === _roles.TradingPlatform
            ? (accountControl.value.balance | money)
            : accountControl.value.balanceFixed)
            | currency: (accountControl.value.currency | fixRateCurrencyConverter)
          }}</div>
          @if ((accountControl.value | accountType) !== 'archived') {
            <a
              class="settings settings--mobile"
              [routerLink]="['accounts', accountControl.value.id]"
              >
              <icon height="16px" name="settings" width="16px" />
            </a>
          }
          @if (isTransactionStatusVisible) {
            <global-transaction-status
              [accountId]="accountControl.value.id"
            />
          }
        </div>
        <div class="buttons">
          @switch (accountControl.value | accountType) {
            @case ('real') {
              <button
                class="button button-border--medium"
                translate="account.link.deposit"
                [queryParams]="{ account: accountControl.value.id }"
                [routerLink]="(isBanned$ | async) ? '/profile/verification' : '/finances/deposit'"
                (click)="trackDepositButtonClick()"
              ></button>
              <button
                class="button button-border button-border--medium button--withdraw"
                routerLink="/finances/withdrawal"
                translate="account.link.withdraw"
                [queryParams]="{ account: accountControl.value.id }"
              ></button>
              @if (accountControl.value.type !== _roles.TradingPlatform) {
                <global-trade-button
                  [account]="accountControl.value"
                  />
              }
            }
            @case ('demo') {
              <global-demo-funds-button
                [account]="accountControl.value"
                />
              @if (accountControl.value.type !== _roles.TradingPlatform) {
                <global-trade-button
                  [account]="accountControl.value"
                  />
              }
            }
            @case ('promo') {
              <button
                class="button button-border button-border--medium"
                translate="account.link.trade"
              ></button>
            }
            @case ('archived') {
              @if ((isRestoring$ | async) === false && accountControl.value.status !== 'restoring') {
                <button
                  class="button button-border button-border--medium"
                  data-qa="dashboard.restore-archive-account.button"
                  translate="account-archive.label.restore"
                  (click)="restoreAccount(accountControl.value)"
                ></button>
              } @else {
                <p class="restore-text" translate="account-archive.message.restoring"></p>
              }
            }
          }
        </div>
      </div>
      @if (depositBonusAvailability?.bonusIsAvailable && !accountControl.value.isDemo) {
        @if (isFullVerification) {
          <global-bonus-banner
            bannerType="bonus-verified"
          [text]="
            depositBonusAvailability.wasReceived
              ? ('deposit-bonus.banner.non-first' | translate)
              : depositCount > 0
                ? ('deposit-bonus.banner.first-old-user' | translate)
                : ('deposit-bonus.banner.first' | translate)
          "
            (click)="onBonusBannerClick(isFullVerification, depositBonusAvailability.wasReceived, depositBonusAvailability.fullTerms)"
            />
        } @else if (!isFullVerification && !isBonusBannerClosed) {
          <global-bonus-banner
            bannerType="bonus-unverified"
            [text]="'deposit-bonus.banner.unverified' | translate"
            (bonusBannerClosed)="onBonusBannerClosed()"
            (click)="onBonusBannerClick(isFullVerification, depositBonusAvailability.wasReceived, depositBonusAvailability.fullTerms)"
            />
        }
      }
      @if ((accountControl.value | accountType) !== 'promo') {
        <hr>
          <pac-sub-menu
            [hasLink]="false"
            [list]="tabs"
            (selected)="selectedTab = $event"
          />
          @switch (selectedTab) {
            @case ('overview') {
              <global-account-viewer-overview
                [account]="accountControl.value"
              />
            }
            @case ('performance') {
              <global-account-viewer-performance
                [account]="accountControl.value"
                [depositBonusExpirationDate]="depositBonusList?.[accountControl.value.id]?.expirationDateFull || ''"
              />
            }
          }
        }
      } @else {
        <section class="opening-account">
          <h2 class="opening-account__title" translate="dashboard.label.opening"></h2>
          <p class="opening-account__description" translate="dashboard.message.opening"></p>
        </section>
      }
    </card-wrapper>
  }


